import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useSubscription } from '../../hooks/useSubscription';
import { useTranslation } from 'react-i18next';
import InternalNavbar from '../../components/InternalNavbar';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import { Helmet } from 'react-helmet-async';
import { FaCrown, FaArrowRight, FaLock } from 'react-icons/fa';
import './style.css';

const DemoExpiredPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const { hasActiveSubscription, loading } = useSubscription();

  const SUBSCRIPTION_PRICE = 49;
  const OLD_PRICE = 59;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (!loading && hasActiveSubscription) {
      navigate('/dashboard');
    }
  }, [hasActiveSubscription, loading, navigate]);

  const handleProceedToPayment = () => {
    navigate('/subscribe');
  };

  if (loading || !user) {
    return null;
  }

  return (
    <div className="demo-expired-page">
      <Helmet>
        <title>{t('demoExpired.pageTitle')}</title>
      </Helmet>
      <InternalNavbar />

      {/* Main Conversion Section */}
      <div className="expired-conversion-section">
        <div className="container">

          {/* Hero Title */}
          <div className="expired-conversion-hero-title">
            <h1>{t('demoExpired.heroTitle')}</h1>
            <h2>{t('demoExpired.heroSubtitle')}</h2>
          </div>

          {/* Horizontal Layout */}
          <div className="row align-items-center expired-conversion-row">

            {/* Left Side - Icon Display */}
            <div className="col-lg-5">
              <div className="expired-icon-display">
                <div className="icon-circle">
                  <FaCrown />
                </div>
                <h3>{t('demoExpired.premiumAccess')}</h3>
                <p>{t('demoExpired.continueJourney')}</p>
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="col-lg-7">
              <div className="expired-conversion-content">

                {/* Welcome Message */}
                <div className="expired-welcome-message">
                  <p>{t('demoExpired.startLearning')}</p>
                </div>

                {/* Value Proposition */}
                <div className="expired-value-proposition">
                  <p>{t('demoExpired.subscribeValue')}</p>
                </div>

                {/* Pricing Display */}
                <div className="expired-pricing-comparison">
                  <div className="expired-price-row">
                    <span className="expired-price-label">{t('demoExpired.oldPrice')}</span>
                    <span className="expired-old-price-amount">${OLD_PRICE}</span>
                  </div>
                  <div className="expired-price-row featured">
                    <span className="expired-price-label">{t('demoExpired.newPrice')}</span>
                    <span className="expired-new-price-amount">${SUBSCRIPTION_PRICE}</span>
                  </div>
                </div>

                {/* CTA Message */}
                <div className="expired-cta-message">
                  <h3>{t('demoExpired.ctaMessage')}</h3>
                </div>

                {/* CTA Button */}
                <button
                  className="btn-proceed-payment-expired"
                  onClick={handleProceedToPayment}
                >
                  {t('demoExpired.proceedToPayment')} <FaArrowRight />
                </button>

                {/* Security Badge */}
                <div className="expired-security-badge">
                  <FaLock /> {t('demoExpired.securePayment')}
                </div>

                {user && (
                  <div className="expired-user-info-minimal">
                    <p>{t('demoExpired.loggedInAs')} <strong>{user.email}</strong></p>
                  </div>
                )}

              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
      <Scrollbar />
    </div>
  );
};

export default DemoExpiredPage;
